import { setWith } from 'lodash';

type ArrayToBeConverted = {
  path: string;
  value: any;
}[];

export function convertArrayToObject<T>(array: ArrayToBeConverted): T {
  const object = {};

  array.forEach((item) => {
    setWith(object, item.path, item.value);
  });

  return object as T;
}
